import {Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild} from "@angular/core";
import {Collateral} from "@app/models/collateral";
import {Constants} from "@app/constants/constants";
import {Branch} from "@app/models/branch";
import {NotificationService} from "@app/services/notification.service";
import {BranchService} from "@app/services/branch.service";
import {CollateralsService} from "@app/services/collaterals.service";
import {AuthenticationService} from "@app/services/authentication.service";
import {MethodsHelper} from "@app/helpers/methods.helper";
import {DatePipe} from "@angular/common";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-collateral-restitution-popup',
    templateUrl: 'collateral-restitution-popup.component.html',
    styleUrls: ['collateral-restitution-popup.component.css'],
    standalone: false
})

export class CollateralRestitutionPopupComponent implements OnInit, OnChanges {
    @Input() displayDialog: boolean;
    @Input() collateralAgreement: Collateral;
    @Output() onSubmit = new EventEmitter();
    @Output() onCancel = new EventEmitter();
    @Output() restitutionReload = new EventEmitter();

    @ViewChild('form') form: any;

    collateralRestitution: any;

    submittedForm: boolean = false;

    validationMessages: object;

    pageIndex = 0;
    pageSize = Constants.PAGE_ITEM_COUNT;
    totalElements: number;

    defaultPageParams = {
        size: 10,
        page: 0
    }

    yearRange: string;

    branchCodeList: Array<Branch>;


    constructor(
        private notificationService: NotificationService,
        private branchService: BranchService,
        private collateralsService: CollateralsService,
        private authenticationService: AuthenticationService,
        private datePipe: DatePipe,
        private translate: TranslateService
    ) {
    }

    ngOnInit() {
        if (!this.collateralRestitution) {
            this.collateralRestitution = new Object();
            this.collateralRestitution.documentNumber = MethodsHelper.randomString(10);
            this.collateralRestitution.collateralAgreementNumber = this.collateralAgreement.collateralAgreementNumber;
            this.collateralRestitution.date = this.datePipe.transform(localStorage.getItem('businessDay') ? new Date(localStorage.getItem('businessDay')) : new Date(), 'dd-MM-yyyy');
            this.collateralRestitution.amount = this.collateralAgreement.outstandingAmount;
            this.collateralRestitution.quantity = this.collateralAgreement.outstandingQuantity;
            this.collateralRestitution.channelCode = Constants.CHANNEL.CHANNEL_CODE;
            this.collateralRestitution.currency = this.collateralAgreement.currency;
            this.collateralRestitution.description = this.collateralAgreement.description;
            this.collateralRestitution.initiatedUserId = this.authenticationService.getCurrentUserId();
            this.collateralRestitution.branchId = this.collateralAgreement.branchId;
            this.collateralRestitution.customerSpecificOptions = this.collateralAgreement.customerSpecificOptions;
            this.collateralRestitution.purpose = this.collateralAgreement.collateralAgreementNumber + ' ' + 'Collateral restitution';
        }
        this.validationMessages = new Object();
        this.yearRange = MethodsHelper.getYearRange(0);
        this.getBranches();
    }

    ngOnChanges() {
        this.getRestitutionInfo();
    }

    getRestitutionInfo() {
        this.collateralsService.getRestitutionInfo(this.collateralAgreement.id).subscribe({
            next: (data) => {
                this.collateralRestitution.documentNumber = data.documentNumber;
                this.collateralRestitution.collateralAgreementNumber = data.collateralAgreementNumber;
                this.collateralRestitution.date = data.date;
                this.collateralRestitution.amount = data.outstandingAmount;
                this.collateralRestitution.quantity = data.outstandingQuantity;
                this.collateralRestitution.currency = data.currency;
                this.collateralRestitution.branchId = data.branchId;
                this.collateralRestitution.purpose = data.purpose;
            },
            error: (err) => {
                let msg = MethodsHelper.showErrorMessageStyling(err);
                this.notificationService.showError("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-times-circle'></i></p><p class='col'> " + `${msg}` + "</p></div>",
                    "");
            }
        });
    }

    getBranches() {
        const pageOption = {
            size: 10000,
            page: 0
        }
        const pageParams = { ...this.defaultPageParams, ...pageOption };
        this.branchService.getList(pageParams).subscribe(data => {
            this.branchCodeList = data.content;
            this.branchCodeList.forEach(code => {
                this.collateralRestitution.branchId = JSON.parse(this.authenticationService.getUserRoles())[0]?.userBranchId;
            })
        });
    }

    onSave() {
        this.submittedForm = true;
        if (this.validateForm()) {
            this.collateralsService.makeRestitution(this.collateralAgreement.id, this.collateralRestitution).subscribe({
                next: (data) => {
                    this.notificationService.showHTMLMessage("<i class='fa fa-check-circle' style='line-height: 2'></i> <p>" + `Successfully restituted.` + "</p>", "");
                    this.cancel();
                    this.restitutionReload.emit();
                },
                error: (err) => {
                    let msg = MethodsHelper.showErrorMessageStyling(err);
                    this.notificationService.showError("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-times-circle'></i></p><p class='col'> " + `${msg}` + "</p></div>",
                        "");
                }
            });
        } else {
            this.notificationService.showErrorMessage(this.translate.instant('error.something_incorrect'))}
    }

    validateForm() {
        for (let key in this.validationMessages) {
            if (this.validationMessages[key]) {
                return false;
            }
        }
        if (this.form.form) {
            return this.form.form.valid
        }
        return false;
    }

    cancel() {
        this.onCancel.emit();
    }

    changeBranch(value) {
        if (this.branchCodeList) {
            for (const element of this.branchCodeList) {
                if (element.id == value) {
                    this.collateralRestitution.branchId = element.id;
                    break;
                }
            }
        }
    }

    onAmountFocusOut(event) {
        this.collateralRestitution.amount = MethodsHelper.amountFieldFocusOut(event);
    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        return !(charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
    }
}